import { gql } from '@apollo/client';

import { TestResultsFragment } from '@modules/testing/graphql/fragments';

export const GetTestResultsQuery = gql`
    query GetOLTestResults($testId: ID, $userId: ID, $subjectId: ID, $courseId: ID) {
        getOLTestResults(
            testId: $testId
            userId: $userId
            subjectId: $subjectId
            courseId: $courseId
        ) {
            ...TestResults
        }
    }
    ${TestResultsFragment}
`;
